import React                from 'react';
import { Observe }               from 'rewire-core';
import MainContentFooterPaging   from '../main-navigation/MainContentFooterPaging';
import batchTimecardSummaryModel from './BatchTimecardSummaryModel';

const TimecardFooter = React.memo(() => {
  return <Observe render={() => (
    <MainContentFooterPaging model={batchTimecardSummaryModel.pagingModel} />
  )} />;
});

export default TimecardFooter;